import React, { Component } from 'react';
import classnames from 'classnames';

type Props = {
  isRegularSSO: boolean;
};

class SSOExplanationText extends Component<Props> {
  getLink = isRegularSSO => {
    return isRegularSSO
      ? 'https://openwebdoc.readme.io/docs/implement-single-sign-on'
      : 'https://openwebdoc.readme.io/docs/implement-third-party-single-sign-on';
  };

  getText = isRegularSSO => {
    return isRegularSSO ? '' : 'Frontend ';
  };

  render() {
    const { isRegularSSO } = this.props;
    const link = this.getLink(isRegularSSO);
    const text = this.getText(isRegularSSO);
    const className = classnames('sso-text', { 'sso-text-3rd-party': !isRegularSSO });
    return (
      <span className={className}>
        {`Our SSO ${text}integration guide is located `}
        <a href={link} target="_blank">
          here
        </a>
        <br />
        For any additional questions and clarifications please contant our Support Team
      </span>
    );
  }
}

export default SSOExplanationText;
